import { render, staticRenderFns } from "./talent7.vue?vue&type=template&id=49134f47&scoped=true"
import script from "./talent7.vue?vue&type=script&lang=js"
export * from "./talent7.vue?vue&type=script&lang=js"
import style0 from "./talent7.vue?vue&type=style&index=0&id=49134f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49134f47",
  null
  
)

export default component.exports